"use client";
import React from "react";
import styles from "../css/index.js";

export default function PharmacyInfoForm({ pharmacyInfo, onChange }) {
  return (
    <div className={styles.bottomSection}>
      <div className={styles.pharmacySection}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionIcon}>🏥</span>
          <h2 className={styles.sectionTitle}>Pharmacy Information</h2>
        </div>

        <div className={styles.pharmacyForm}>
          <div className={styles.pharmacyGrid}>
            <div className={styles.inputGroup}>
              <label className={styles.label}>Pharmacy Name</label>
              <input
                type="text"
                value={pharmacyInfo.name}
                onChange={(e) => onChange("name", e.target.value)}
                className={styles.input}
                readOnly
                disabled
              />
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.label}>Pharmacy Address</label>
              <input
                type="text"
                value={pharmacyInfo.address}
                onChange={(e) => onChange("address", e.target.value)}
                className={styles.input}
                readOnly
                disabled
              />
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.label}>Phone Number (Optional)</label>
              <input
                type="text"
                value={pharmacyInfo.phone}
                onChange={(e) => onChange("phone", e.target.value)}
                className={styles.input}
                placeholder=""
                readOnly
                disabled
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
